/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Queuedescription1Inputs */

const en_entity_queuedescription1 = /** @type {(inputs: Entity_Queuedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Queue Description`)
};

const de_entity_queuedescription1 = /** @type {(inputs: Entity_Queuedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Queue Description" |
*
* @param {Entity_Queuedescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_queuedescription1 = /** @type {((inputs?: Entity_Queuedescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Queuedescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_queuedescription1(inputs)
	return de_entity_queuedescription1(inputs)
});
export { entity_queuedescription1 as "entity_queueDescription" }